import React from 'react';
import { Redirect } from 'react-router-dom';

const Callback = () => {
    const previousUrl = localStorage.getItem('previousUrl');

    return (
        <Redirect to={previousUrl || '/'}/>
    )
}

export default Callback;